import { AUTO_LOGOUT_PERIODS_MINUTES } from '~/models/UserInfoModel';
export const LAST_USER_INTERACTION_LOCAL_STORAGE_KEY = 'lastUserInteraction';
export const AUTO_LOGOUT_PERIOD_LOCAL_STORAGE_KEY = 'autoLogoutPeriodMinutes';
export const announceAutoLogoutPeriod = (localStorage, minutes)=>{
    try {
        localStorage.setItem(AUTO_LOGOUT_PERIOD_LOCAL_STORAGE_KEY, String(minutes));
        localStorage.removeItem(AUTO_LOGOUT_PERIOD_LOCAL_STORAGE_KEY);
    } catch (unused) {
    // Storage is blocked (private browsing): other tabs pick the period up when they reload.
    }
};
export const announcedAutoLogoutPeriod = (event)=>{
    if (event.key !== AUTO_LOGOUT_PERIOD_LOCAL_STORAGE_KEY) {
        return null;
    }
    const minutes = Number(event.newValue);
    return AUTO_LOGOUT_PERIODS_MINUTES.includes(minutes) ? minutes : null;
};
